<template>
  <div>
    <el-row class="title">
      <el-col :span="24" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-description">
            <div class="card-panel-text">待办信息</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="0" class="panel-group">
      
      <el-col :span="isMB ? 24 : 12" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <i class="el-icon-s-cooperation card-panel-icon" />
          </div>
          <div
            class="card-panel-description"
            style="cursor: pointer"
            @click="toPage('/sale/order?state=1')"
          >
            <count-to
              :start-val="0"
              :end-val="data.WaitsendorderCount"
              :duration="2500"
              class="card-panel-num"
            />
            <div class="card-panel-text">待发货订单</div>
          </div>
        </div>
      </el-col>
      <el-col :span="isMB ? 24 : 12" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <i class="el-icon-s-claim card-panel-icon" />
          </div>
          <div
            class="card-panel-description"
            style="cursor: pointer"
            @click="toPage('/sale/order?state=2')"
          >
            <count-to
              :start-val="0"
              :end-val="data.WaitacceptorderCount"
              :duration="2000"
              class="card-panel-num"
            />
            <div class="card-panel-text">待收货订单</div>
          </div>
        </div>
      </el-col>
      <el-col :span="isMB ? 24 : 12" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-money">
            <i class="el-icon-s-release card-panel-icon" />
          </div>
          <div class="card-panel-description" style="cursor: pointer"
            @click="toPage('/sale/order?state=3')">
            <count-to
              :start-val="0"
              :end-val="data.WaitaftersaleorderCount"
              :duration="2500"
              class="card-panel-num"
            />
            <div class="card-panel-text">待售后订单</div>
          </div>
        </div>
      </el-col>

      <el-col :span="isMB ? 24 : 12" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-money">
            <i class="el-icon-s-order card-panel-icon" />
          </div>
          <div
            class="card-panel-description"
            style="cursor: pointer"
            @click="toPage('/sale/apply?State=1')"
          >
            <count-to
              :start-val="0"
              :end-val="data.ApplyCount"
              :duration="2000"
              class="card-panel-num"
            />
            <div class="card-panel-text">待处理补货</div>
          </div>
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import CountTo from "vue-count-to";

export default {
  components: {
    CountTo,
  },
  data() {
    return {
      data: {
        BusinessReviewCount: 0,
        BstrinReviewCount: 0,
        BstrcpReviewCount: 0,
        OrderReviewCount: 0,
        OrderCount: 0,
        WaitsendorderCount : 0,
        WaitacceptorderCount: 0,
        WaitaftersaleorderCount: 0,
        ApplyCount: 0,
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    setData(data) {
      this.data.BusinessReviewCount = data.BusinessReviewCount;
      this.data.BstrinReviewCount = data.BstrinReviewCount;
      this.data.BstrcpReviewCount = data.BstrcpReviewCount;
      this.data.OrderReviewCount = data.OrderReviewCount;
      this.data.ApplyCount= data. ApplyCount;
       this.data.OrderCount = data.OrderCount;
      this.data.WaitsendorderCount=data.WaitsendorderCount;
      this.data.WaitacceptorderCount=data.WaitacceptorderCount;
      this.data.WaitaftersaleorderCount=data.WaitaftersaleorderCount;

    },
    toPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  .card-panel-col {
    border-bottom: solid 1px rgba(0, 0, 0, 0.03);
  }

  .card-panel {
    height: 50px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    z-index: 1;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);

    .card-panel-description {
      float: left;
      font-weight: bold;
      margin-left: 25px;

      .card-panel-text {
        line-height: 50px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 18px;
      }
    }
  }
}

.panel-group {
  padding: 0 0 0 50px;
  @media screen and (max-width: 480px) {
    padding: 0 10px;
  }
  // .card-panel-col {
  //   margin-bottom: 45px;
  // }
  .card-panel {
    margin: 20px 0;
    height: 108px;
    cursor: default;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    // box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    // border-color: rgba(0, 0, 0, 0.05);
    @media screen and (max-width: 480px) {
      margin: 0;
    }
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #34bfa3;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #4e6ab8;
      }
    }

    .icon-people {
      color: #34bfa3;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #4e6ab8;
    }

    .card-panel-icon-wrapper {
      float: left;
      // margin: 14px 0 0 14px;
      padding: 16px;
      padding-right: 0;
      padding-left: 0;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 80px;
      @media screen and (max-width: 480px) {
        font-size: 68px;
      }
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      width: 48%;
      margin: 0;
      margin-top: 26px;
       margin-right: 30px;
      @media screen and (max-width: 480px) {
        margin-top: 15px;
      }
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 20px;
        margin-top: 16px;
      }

      .card-panel-num {
        font-size: 24px;
      }
    }
  }
}
// @media (max-width: 550px) {
//   .card-panel-description {
//     display: none;
//   }

//   .card-panel-icon-wrapper {
//     float: none !important;
//     width: 100%;
//     height: 100%;
//     margin: 0 !important;

//     .svg-icon {
//       display: block;
//       margin: 14px auto !important;
//       float: none !important;
//     }
//   }
// }
</style>
